module.exports = __webpack_public_path__ + "static/media/IMG_0395.23e59b46.JPG";